import { AxiosRequestHeaders } from 'axios';

const defaultHeaders: AxiosRequestHeaders = {
  Pragma: 'no-cache',
  'Content-Type': 'application/json',
};

export default defaultHeaders;
